import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { Button } from "@progress/kendo-react-buttons";
import "./SignInButton.scss";



const SignInButton = () => {
    const { instance } = useMsal();
    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch((e) => {
        });
    }

    return (
        <Button className={"signInButton"} fillMode={"link"} onClick={() => handleLogin()}>
            <span className="k-icon k-i-login">&nbsp;</span>State Login
        </Button>
    );
};

export default SignInButton